import request from 'lib/request';

export interface Response {
  code: number;
  data: Data;
  msg: string;
}

export interface Data {
  oauth_url: string;
}

export async function projectTwitterOauthUrl(
  project_id: number,
  redirect_url: string
) {
  const res = await request<Response>('/project/twitter_oauth_url', {
    params: { project_id, redirect_url },
  });

  return res?.data;
}
